// extracted by mini-css-extract-plugin
export default {"menuItemDisabled":"NavigationMenu_menuItemDisabled__EcBFV"};